export const WEATHER_DAY_SWIPE_IGNORE_ATTR = 'data-weather-day-swipe-ignore';

/** Spread onto plot hit-targets so day swipe ignores scrubbable chart areas. */
export const weatherDaySwipeIgnoreProps = {
  [WEATHER_DAY_SWIPE_IGNORE_ATTR]: 'true',
} as const;

export const isWeatherDaySwipeIgnoredTarget = (
  target: EventTarget | null,
): boolean => {
  if (!(target instanceof Element)) {
    return false;
  }

  return target.closest(`[${WEATHER_DAY_SWIPE_IGNORE_ATTR}="true"]`) != null;
};
